import useSessionStorage from "./useSessionStorage";

function useCancelRedirect() {
  const [url, setUrl] = useSessionStorage("cancelRedirectUrl");
  const params = new URLSearchParams(window.location.search);
  const newUrl = params.get("cancelRedirectUrl");
  if (newUrl && newUrl !== url) {
    setUrl(newUrl);
    return newUrl;
  }
  return url;
}

export default useCancelRedirect;
